import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "@/pages/comp/book_order/textbook/common/list/area/search";
import RightViewArea from "./area/right_view";

function TextBookListViewArea(props: any) {
  let myProps = {
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_title_like: "",
    s_subject: "영어",
    s_category_seq: "1",
    s_sort1_seq: "7",
    s_sort2_seq: "",
    s_sort3_seq: "",
    s_addon_section: "1",
    s_addon_study: "1",
  });
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [select_textbook_info,set_select_textbook_info] = useState({});

  useEffect(() => {
    list({});
  }, []);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt({ ...tmp_list_opt });
    if (tmp_list_opt.is_excel_down) {
      tmp_list_opt.is_paging = "";
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.a_seq == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {
    set_select_textbook_info(rowData);
  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */

    return params.value;
  };

  return (
    <div>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width={"40%"}></col>
          <col width={"*"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top", paddingRight: "10px" }}>
              <div style={{ minWidth: "500px" }}>
                <SearchArea
                  listOpt={listOpt}
                  setListOpt={setListOpt}
                  list={list}
                ></SearchArea>
                <div className="mt-1">
                  <ListComponent
                    ref={ListComponentRef}
                    xColumnArr={{ ...xColumnArr }}
                    gridOpt={{
                      fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
                      is_add_idx_num: false,
                      is_add_checkbox: false,
                      td_align: "center",
                      //height: "auto",
                      is_fix_width: true,
                      rowMultiSelectWithClick: false,
                      onGridReady: () => {

                      },

                      is_all_select_row_key: true,
                      rowOnClick: rowOnClick,
                      customCellRenderer: customCellRenderer,
                      class_name_json: {
                        table_div: "basic_list_div",
                        td_div: "row-col-div",
                        input_check: "chk_row",
                        row_input: "row-input",
                        data_row_tr: "data_row_tr",
                        active_row: "active",
                        empty_con_div: "list_empty_content_div",
                      },
                    }}
                  ></ListComponent>
                </div>
                <Paging now_page={listOpt.now_page}
                  num_per_page={listOpt.num_per_page}
                  total_rec={countInfo.tot}
                  onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
                  is_view_num_per_page={true}
                  is_show_total_rec={true}
                  onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "500px" }}>
                <RightViewArea
                  textbook_info={select_textbook_info}
                ></RightViewArea>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default TextBookListViewArea;